import {
  CALCULATOR_DETAILS_SAVE_REQUEST,
  DELETE_CALCULATOR_REQUEST,
  EDIT_CALCULATOR_REQUEST,
  GET_CALCULATOR_REQUEST,
  RESET_BLOCK_CALCULATOR,
  RESET_FLAGS_CALCULATOR,
  SET_CALCULATOR_PLATFORM,
  SHOW_MOBILE_MODAL,
} from "../reducers/CalculatorReducer";

export const calculatorSaveAPI = (payload) => ({
  type: CALCULATOR_DETAILS_SAVE_REQUEST,
  payload,
});

export const getCalculator = (payload) => ({
  type: GET_CALCULATOR_REQUEST,
  payload,
});
export const deleteCalculator = (payload) => ({
  type: DELETE_CALCULATOR_REQUEST,
  payload,
});

export const editCalculator = (payload) => ({
  type: EDIT_CALCULATOR_REQUEST,
  payload,
});

export const setCalculatorPlatform = (payload) => ({
  type: SET_CALCULATOR_PLATFORM,
  payload,
});

export const showMobileHeaderModal = (payload) => ({
  type: SHOW_MOBILE_MODAL,
  payload,
});

export const resetBlockOnboarding = (payload) => ({
  type: RESET_BLOCK_CALCULATOR,
  payload,
});

export const resetFlagsOnboarding = (payload) => ({
  type: RESET_FLAGS_CALCULATOR,
  payload,
});
